import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';

interface TermsCopyProps {
  i18nKey: string;
}

const TermsCopy = ({ i18nKey }: TermsCopyProps): JSX.Element => (
  <Trans
    i18nKey={i18nKey}
    components={{
      b: <b />,
      u: (
        <Box
          component="span"
          sx={{ textDecoration: 'underline', fontWeight: 700 }}
        />
      ),
    }}
  />
);

export default TermsCopy;
